import { Navigate, useLocation } from "react-router-dom";
import React from "react";
import { store } from "../reducer/Store";

/**
 * Ce composant représente une route privée de l'application.
 *
 * @param {Array} roles - Les rôles d'utilisateur autorisés à accéder à la route. Par défaut, la valeur est [-1], ce qui signifie que tous les utilisateurs authentifiés peuvent accéder à la route.
 * @param {ReactNode} children - Les éléments enfants à afficher lorsque l'utilisateur est autorisé à accéder à la route.
 *
 * @returns {ReactNode} - Les éléments enfants à afficher si l'utilisateur est autorisé à accéder à la route, sinon une redirection vers la page de connexion ou une autre page en fonction du contexte.
 *
 * Si l'utilisateur n'est pas authentifié, le composant redirige vers la page de connexion avec l'état de la localisation actuelle.
 *
 * Si l'utilisateur est authentifié mais n'a pas le rôle requis pour accéder à la route, le composant redirige vers la page "/client" (ou une autre page définie pour les accès refusés).
 *
 * Si l'utilisateur est authentifié et a le rôle requis, mais la localisation actuelle est la racine ("/"), le composant redirige vers la page "/client" (ou une autre page définie comme page d'accueil).
 *
 * Sinon, le composant affiche les éléments enfants fournis.
 */
const PrivateRoute = ({ roles = [-1], children }) => {
  const { state } = React.useContext(store);
  let location = useLocation();
  const include =
    roles === -1
      ? false
      : roles.includes(parseInt(localStorage.getItem("user_role")));
  const userHasRequiredRole = state.isAuth && include ? true : false;

  /*  const notSelected =
    JSON.parse(localStorage.getItem("dataSelectedCustomer")) &&
    JSON.parse(localStorage.getItem("dataSelectedCustomer")).id
      ? true
      : false; */

  if (!state.isAuth) {
    return <Navigate to="/login" state={{ from: location }} />;
  }

  if (state.isAuth && !userHasRequiredRole) {
    return <Navigate to="/client" />; // build view denied page (sth like 404) => we dont do it
  }

  if (state.isAuth && location.pathname === "/") {
    return <Navigate to="/client" />;
  }
  return children;
};

export default PrivateRoute;
